import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  MapContainer,
  TileLayer,
  Polyline,
  CircleMarker,
  Tooltip,
  Marker,
} from "react-leaflet";
import L from 'leaflet';
import "leaflet/dist/leaflet.css";
import { getTrackingData } from "../../../redux/actions/todoPerformance";

const TrackingTab = () => {
  const dispatch = useDispatch();
  const { activity_assignment_id } = useParams();
  const [trackingData, setTrackingData] = useState(null);
  const [routeData, setRouteData] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const isComplete = useRef(true);
  const centerPosition = useRef([20.0, 65.0]);

  useEffect(() => {
    if (activity_assignment_id) {
      dispatch(
        getTrackingData(activity_assignment_id, (result) => {
          if (result.status) {
            const { tracking_object } = result.data;
            const parsedata = JSON.parse(tracking_object ?? "{}");
            setTrackingData(parsedata);
          } else{
            setDataLoaded(true);
          }
        })
      );
    }
  }, [activity_assignment_id]);

  useEffect(() => {
    if (trackingData && Object.keys(trackingData).length > 0) {
      if (trackingData?.route_data) {
        setRouteData(trackingData.route_data);
        if(trackingData?.route_data?.pin){
          centerPosition.current = trackingData?.route_data?.pin;
        }
        setDataLoaded(true);
      } else{
        setDataLoaded(true);
      }
    }
  }, [trackingData]);

  const shipIcon = new L.DivIcon({
    html: `<i class="fa-regular fa-ship" style="background: var(--bg-color-500); color: white; border-radius: 50%; padding: 4px;"></i>`,
    className: 'text-sm bg-[#2F80ED] bg-opacity-40 text-white rounded-full flex justify-center items-center', // Avoid default Leaflet icon styling
    iconSize: [40, 40],
    iconAnchor: [20, 20],
  });

  return (
    <div
      className={`sm:pt-2 overflow-y-auto overflow-x-hidden h-screen space-y-8 relative`}
      style={{
        maxHeight: "calc(100vh - 136px)",
      }}
    >
      {
        dataLoaded && (
          <MapContainer
            center={centerPosition.current}
            zoom={3}
            style={{ height: "100%", width: "100%", zIndex: 20 }}
          >
            <TileLayer
              url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
            //   attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              opacity={0.9}
              // zIndex={10}
            />

            {routeData?.pin && (
              <Marker
                position={routeData?.pin}
                icon={shipIcon}                
              />
            )}

            {routeData?.route?.map((item) => {
              let completedPath = [];
              let incompletedPath = [];
              if(item.type === "LAND"){
                completedPath = item.path;
              }
              if(routeData?.pin && item.type !== "LAND"){
                const currentPosition = JSON.stringify(routeData?.pin);
                item?.path?.forEach((ele) => {
                  if(JSON.stringify(ele) === currentPosition && isComplete.current){
                    isComplete.current = false;
                    completedPath.push(ele);
                  }
                  if(isComplete.current){
                    completedPath.push(ele);
                  } else {
                    incompletedPath.push(ele);
                  }
                })
              }
              return (
                <> 
                  <Polyline
                    positions={completedPath}
                    pathOptions={{
                      color: 'var(--bg-color-500)',
                      weight: 2,
                    }}
                  /> 
                  <Polyline
                    positions={incompletedPath}
                    pathOptions={{
                      color: 'var(--bg-color-500)',
                      weight: 2,
                      dashArray: "4",
                      dashOffset: "5",
                    }}
                  /> 
                  {/* {
                      item.type === "LAND" ? (
                          <Polyline
                            positions={item.path}
                            pathOptions={{
                              color: 'var(--bg-color-500)',
                              weight: 2,
                            }}
                          />
                      ) : (
                          <Polyline
                            positions={item.path}
                            pathOptions={{
                              color: 'var(--bg-color-500)',
                              weight: 2,
                              dashArray: "4",
                              dashOffset: "5",
                            }}
                          />
                      )
                  } */}
                  <CircleMarker
                    center={[item.from.lat, item.from.lng]}
                    radius={4}
                      pathOptions={{
                      // color: 'green',
                      weight: 0,
                      fill: true,
                      fillColor: 'var(--bg-color-500)',
                      fillOpacity: '1',
                      fillRule: 'nonzero',
                    }}
                  >
                    <Tooltip direction="right" offset={[10, 0]} permanent>
                        {`${item?.from?.name ?? ""}, ${item?.from?.state || ""}, ${item?.from?.country ?? ""}`}
                    </Tooltip>
                  </CircleMarker>
                  <CircleMarker
                    center={[item.to.lat, item.to.lng]}
                    radius={4}
                    pathOptions={{
                    // color: 'green',
                      weight: 0,
                      fill: true,
                      fillColor: 'var(--bg-color-500)',
                      fillOpacity: '1',
                      fillRule: 'nonzero',
                    }}
                  >
                    <Tooltip direction="right" offset={[10, 0]} permanent>
                        {`${item?.to?.name ?? ""}, ${item?.to?.state || ""}, ${item?.to?.country ?? ""}`}
                    </Tooltip>
                  </CircleMarker>
                </>
              )
            })}
          </MapContainer>
        )
      }
      
    </div>
  );
};

export default TrackingTab;
